import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uint8ArrayToBase64 } from "src/utils/uploadPhotos";
// import damageCodeData from "../../../public/static/json/damageCode";
import damageCode from "@myjourney-assets/json/damageCode.json";
import { Button, RoundedButton, Typography } from "@packages/ui";
import brandColors from "@packages/ui/theme/colors";
import VirImageButton from "src/components/VirImageButton/VirImageButton";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Checkbox,
  FormHelperText,
  TextField,
} from "@material-ui/core";
import { Controller, useForm } from "react-hook-form";
import { ATHENA_VIR_PREPARE_BE, ATHENA_VIR_PREPARE_THERMEON } from "src/types/actions";
import JSZip from "jszip";
import * as virActions from "src/actions/virActions";
import "react-image-lightbox/style.css";
import { useIsMount } from "src/hooks/useIsMount";
import * as appActions from "../../actions/appActions";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const DigitalVIRDamageDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const brand = getBrandFromUrl().toLowerCase();

  const selectedVirType = useSelector((state) => state.vir?.athenaSelectedType?.selectedType);
  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const damageCode = damageCodeData?.damageCode || {};
  const patchedDetails = useSelector((state) => state.vir?.athenaVirDetailPatch);
  const [loading, setLoading] = useState(false);
  const isMount = useIsMount();
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);
  const athenaVirDetail = useSelector((state) => state.vir?.athenaVirDetail);
  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const athenaRole = useSelector((state) => state.vir?.athenaRole?.role);
  const disableEdit = resubmitFlag && athenaRole !== "staff";
  const previousData = resubmitFlag ? athenaVirDetail?.data : patchedDetails?.data;
  const damageImages = useSelector(
    (state) => state.vir?.virPrepareTHERMEON?.damage?.primary?.photos || []
  );
  const otherdriverImages = useSelector(
    (state) => state.vir?.virPrepareTHERMEON?.otherdriver?.primary?.photos || []
  );
  const witnessImages = useSelector((state) => state.vir?.virPrepareTHERMEON?.witness || {});
  const thirdpartyImages = useSelector((state) => state.vir?.virPrepareTHERMEON?.thirdparty || {});

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isDirty },
    watch,
  } = useForm({
    defaultValues: {
      serviceCode: previousData?.DamageDetails?.DamageCodes || [],
      additionalDetails: previousData?.AddtionalDetails || "",
      documents: [],
    },
    mode: "onBlur",
  });
  const additionalDescription = watch("additionalDetails", "");

  const [anchorEl, setAnchorEl] = useState(null);
  const [tempSelection, setTempSelection] = useState([]);
  useEffect(() => {
    if (!isMount) {
      if (!patchedDetails.loading && loading) {
        setLoading(false);
        if (patchedDetails.error) {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Failed to update",
            })
          );
        } else {
          dispatch(
            appActions.createToast({
              type: "success",
              message: "Vehicle Incident Report is updated",
            })
          );
          dispatch(
            virActions.detailVir({
              virId: selectedVirid,
            })
          );
          navigate(`/vehicleincidents/reviewpage?brand=${brand}`);
        }
      }
    }
  }, [patchedDetails.loading]);

  const handleServiceCodeChange = (event) => {
    const selectedIds = event.target.value;
    const updatedServiceCode = selectedIds
      .map((id) => {
        for (const key in damageCodeData) {
          if (damageCodeData[key].ID === id) {
            return {
              Type: damageCodeData[key].Type,
              ID: damageCodeData[key].ID,
              Name: damageCodeData[key].Name,
              Description: damageCodeData[key].Description,
            };
          } else if (typeof damageCodeData[key] === "object") {
            for (const subKey in damageCodeData[key]) {
              if (damageCodeData[key][subKey].ID === id) {
                return {
                  Type: damageCodeData[key][subKey].Type,
                  ID: damageCodeData[key][subKey].ID,
                  Name: damageCodeData[key][subKey].Name,
                  Description: damageCodeData[key][subKey].Description,
                };
              }
            }
          }
        }
        return null;
      })
      .filter(Boolean);

    setValue("serviceCode", updatedServiceCode);
  };

  const zipFile = async (data) => {
    const zip = new JSZip();
    data.forEach((file) => {
      const base64Data = file.preview.split(",")[1]; // Remove the base64 header if necessary
      const byteArray = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
      zip.file("image_" + Date.now() + "_" + file.name + ".jpg", byteArray);
    });

    const zipBlob = await zip.generateAsync({ type: "blob" });
    const arrayBuffer = await zipBlob.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    return uint8ArrayToBase64(uint8Array);
  };

  const collectAllPhotos = (obj) => {
    const allPhotos = [];

    const traverse = (current) => {
      if (Array.isArray(current)) {
        return;
      }
      for (const key in current) {
        if (key === "photos" && Array.isArray(current[key])) {
          allPhotos.push(...current[key]);
        } else if (typeof current[key] === "object" && current[key] !== null) {
          traverse(current[key]);
        }
      }
    };
    traverse(obj);
    return allPhotos;
  };

  const onSubmit = async (data) => {
    if (!data.serviceCode || (data.serviceCode.length === 0 && selectedVirType === "panel")) {
      dispatch(
        appActions.createToast({
          type: "error",
          message: "Select multiple damages",
        })
      );
      return;
    } else if (
      !data.serviceCode ||
      (data.serviceCode.length === 0 && selectedVirType === "windscreen")
    ) {
      dispatch(
        appActions.createToast({
          type: "error",
          message: "Select atleast one of the  records",
        })
      );
      return;
    }
    setLoading(true);
    const virPayloadBE = {};
    const virPayloadTHERMEON = {};

    virPayloadTHERMEON["ServiceCode"] = data.serviceCode;

    // zip damage photos
    const damageZipData = await zipFile(damageImages);

    // thrid party photos
    const thirdPartyPhotos = collectAllPhotos(thirdpartyImages);

    // witness photos
    const witnessPhotos = collectAllPhotos(witnessImages);

    const driverLicensePhotos = [...witnessPhotos, ...thirdPartyPhotos, ...otherdriverImages];
    const driverLicenseZipData = await zipFile(driverLicensePhotos);

    virPayloadBE["driverLicensePhotos"] = driverLicenseZipData;
    // virPayloadBE["witnessPhotos"] = witnessZipData;
    // virPayloadBE["otherdriverPhotos"] = otherdriverZipData;

    virPayloadBE["AdditionalDetails"] = data.additionalDetails;
    virPayloadBE["damagePhotos"] = damageZipData;
    dispatch({ type: ATHENA_VIR_PREPARE_BE, payload: virPayloadBE });

    const param = {
      virId: selectedVirid,
      virStatus: "DamageDetails",
      data: {
        DamageDetails: {
          DamageCodes: data.serviceCode,
        },
        AddtionalDetails: data.additionalDetails,
      },
    };
    if (athenaSource === "sms" && isDirty) {
      param.data.CustomerEditBySms = true;
    }
    dispatch(virActions.detailPatchVir(param));
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <h2 className={classes.heading}>Please complete the damage details.</h2>

        <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] || brandColors.default }} />

        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Select location of damage</InputLabel>

            <Controller
              name="serviceCode"
              control={control}
              defaultValue={[]}
              rules={{
                validate: (value) => value.length <= 5 || "You can select up to 5 records.",
              }}
              render={({ field: { onChange, value: selectedItems } }) => (
                <Select
                  multiple
                  label="Select location of damage"
                  value={selectedItems.map((item) => item.ID)}
                  onChange={(event) => {
                    if (event.target.value.length > 5) {
                      return;
                    }
                    handleServiceCodeChange(event);
                  }}
                  renderValue={(selected) =>
                    selected.map((id) => damageCode[id]?.Name || id).join(", ")
                  }
                  disabled={
                    disableEdit &&
                    previousData?.DamageDetails?.DamageCodes !== "" &&
                    previousData?.DamageDetails?.DamageCodes !== undefined
                  }
                >
                  {damageCodeData &&
                    Object.entries(damageCodeData)
                      .filter(([key]) => {
                        if (selectedVirType === "windscreen") {
                          return ["Windscreen", "Tyre"].includes(key);
                        } else if (selectedVirType === "panel") {
                          return ![
                            "Windscreen",
                            "Tyre",
                            "InteriorOrMissingItems",
                            "Mechanical",
                          ].includes(key);
                        } else if (selectedVirType === "interior") {
                          return ["InteriorOrMissingItems"].includes(key);
                        } else if (selectedVirType === "mechanical") {
                          return ["Mechanical"].includes(key);
                        }
                        return true;
                      })
                      .flatMap(([key, value]) =>
                        typeof value === "object" && !value.ID
                          ? Object.entries(value).map(([_, subValue]) => (
                              <MenuItem key={subValue.ID} value={subValue.ID}>
                                <Checkbox
                                  checked={selectedItems
                                    .map((item) => item.ID)
                                    .includes(subValue.ID)}
                                />
                                <ListItemText primary={subValue.Name} />
                              </MenuItem>
                            ))
                          : [
                              <MenuItem key={value.ID} value={value.ID}>
                                <Checkbox
                                  checked={selectedItems.map((item) => item.ID).includes(value.ID)}
                                />
                                <ListItemText primary={value.Name} />
                              </MenuItem>,
                            ]
                      )}
                </Select>
              )}
            />
            {errors.serviceCode && <FormHelperText>{errors.serviceCode.message}</FormHelperText>}
          </FormControl>
          <VirImageButton category={"damage"} index={"primary"} />
          <TextField
            // label="Do you want to provide any additional details?"
            placeholder="Do you want to provide any additional details?"
            multiline
            minRows={4}
            variant="outlined"
            fullWidth
            margin="normal"
            {...register("additionalDetails", {
              // required: "Please enter Additional Details...",
              maxLength: {
                value: 500,
                message: "Additional details cannot exceed 500 characters",
              },
            })}
            inputProps={{ maxLength: 500 }}
            error={!!errors.additionalDetails}
            helperText={errors.additionalDetails?.message || `${additionalDescription.length}/500`}
          />
          <RoundedButton
            variant="contained"
            fullWidth
            sx={{ mt: 2, width: "80%", margin: "2" }}
            type="submit"
            disabled={loading}
          >
            {loading ? <CircularProgress /> : "Review Form"}
          </RoundedButton>
        </form>
      </Box>
    </>
  );
};

export default DigitalVIRDamageDetails;
